import { Group } from "@mantine/core";
import ResponseQuality from "./ResponseQuality";
import PerfRate from "../../activities/perf/PerfRate";
import { useReportingStore } from "../../../../../stores/ReportingStore";
import PerfRateMulti from "../../activities/perf/PerfRateMulti";
import PerfDelivrabilityMulti from "../../activities/perf/PerfDelivrabilityMulti";
import PerfDelivrability from "../../activities/perf/PerfDelivrability";

const EmailPerf = () => {
  const programmations = useReportingStore((s) => s.programmations);

  return (
    <Group gap={"xl"} w={"100%"} align="stretch" wrap="nowrap">
      {programmations.length > 1 ? <PerfRateMulti /> : <PerfRate />}

      {programmations.length > 1 ? (
        <PerfDelivrabilityMulti />
      ) : (
        <PerfDelivrability />
      )}

      <ResponseQuality />
    </Group>
  );
};

export default EmailPerf;
